<template>
  <tr 
    v-if="viewPort == 'large'"
    ref="item"
    :class="{
      'requested': curItem.status != 'NEW'
    }"
    @mouseover="startAnimation"
    @mouseleave="stopAnimation"
  >
    <td class="number">
      <a 
        href="#"
        @click.prevent="$router.push(`mail-group?id=${curItem.id}`)"
      >{{curItem.id}}</a>
    </td>
    <td>{{curItem.user_name}}</td>
    <td class="sm-txt-center qty">{{curItem.quantity}}</td>
    <td>
      <template v-if="curItem.created_date">{{curItem.created_date.split('T')[0] | moment('MMM D, YYYY')}}</template>
    </td>
    <td>
      <template v-if="curItem.forwarded_date">{{curItem.forwarded_date | moment('MMM D, YYYY')}}</template>
    </td>
    <td 
      class="status"
      :class="{
        'sm-txt-nowrap': reminderToday
      }"
    >
      <lottie
        v-if="reminderToday"
        :options="options"
        :width="40"
        :height="40"
        @animCreated="saveAnimation"
      />
      <span
        class="sm-txt-capitalize"
        :class="{
          'new': curItem.status.toLowerCase() == 'new',
          'reminder': reminderToday
        }"
      >
        {{curItem.status.toLowerCase()}}
      </span>
      <hint-wrap 
        v-if="curItem.tracking_code"
        :text="'View tracking code'"
        :delay="0"
      >
        <template slot="content">
          <a
            v-if="curItem.tracking_code"
            href="#"
            class="sm-link"
            @click.prevent="$router.push(`tracking?item=${curItem.id}&group=1`)"
          >
            <include-svg :name="'icon-tracking'" />
          </a>
        </template>
      </hint-wrap>
    </td>
    <td class="group-mail-actions">
      <div 
        v-if="!curItem.tracking_code && curItem.status != 'GroupMail Forwarded'"
        class="sm-list__table-actions visible"
      >
        <div
          v-for="action in curItem.actions"
          :key="action.name"
          class="sm-list__table-action"
        >
          <a
            href="#"
            class="icon"
            @click.prevent="$emit('action', {
              action: action.name, 
              id: curItem.id
            })"
            @mouseenter="actionEnter(action)"
            @mouseleave="actionLeave(action)"
          >
            <include-svg :name="action.btn.icon" />
            <hint-block v-if="action.showHint">
              <template slot="hintContent">{{action.btn.text}}</template>
            </hint-block>
          </a>
        </div>
      </div>
      <div
        class="sm-list__table-actions-mobile" 
        :class="{
          'disabled': curItem.tracking_code || curItem.status == 'GroupMail Forwarded'
        }"
        @click="showPopup"
    >
        <a href="#"></a>
      </div>
      <div class="sm-list__table-actions-popup" 
        v-if="curItem.popupOpen" 
        v-click-outside="hidePopup"
      >
        <ul>
          <li
            v-for="action in curItem.actions"
            :key="action.name"
          >
            <a
              href="#"
              @click.prevent="$emit('action', {
                action: action.name, 
                id: curItem.id
              })"
            >{{action.btn.text}}</a>
          </li>
        </ul>
      </div>
    </td>
  </tr>
  <div
    v-else
    class="sm-mobile-table-item" 
    ref="item"
    :class="{
      'open': curItem.itemOpen,
      'requested': curItem.status != 'NEW'
    }"
  >
    <div class="sm-mobile-table-item-row">
      <div
        class="sm-mobile-table-item-row-elem customer"
        @click="toggleItem"
      >
        <include-svg :name="'icon-arrow-b-bold'" />
        <span>{{curItem.user_name}}</span>
      </div>
      <div class="sm-mobile-table-item-row-elem id sm-txt-center">
        <a 
          href="#"
          @click.prevent="$router.push(`mail-group?id=${curItem.id}`)"
        >{{curItem.id}}</a>
      </div>
      <div class="sm-mobile-table-item-row-elem qty sm-txt-center">{{curItem.quantity}}</div>
      <div
        class="sm-mobile-table-item-row-elem actions" 
        :class="{
          'disabled': curItem.tracking_code || curItem.status == 'GroupMail Forwarded'
        }"
        @click="showPopup"
      >
        <a href="#"></a>
      </div>
    </div>
    <ul class="sm-mobile-table-item-dropdown group">
      <li>
        <span>Created</span>
        <span>
          <template v-if="curItem.created_date">{{curItem.created_date.split('T')[0] | moment('MMM D, YYYY')}}</template>
        </span>
      </li>
      <li v-if="curItem.forwarded_date">
        <span>Forwarded</span>
        <span>
          <template v-if="curItem.forwarded_date">{{curItem.forwarded_date | moment('MMM D, YYYY')}}</template>
        </span>
      </li>
      <li>
        <span>Status</span>
        <span>
          <span 
            class="sm-txt-capitalize"
            :class="{
              'new': curItem.status.toLowerCase() == 'new',
              'reminder': reminderToday
            }"
          >
            <!-- {{curItem.status_label.split(/\./g)[0]}} -->
            {{curItem.status}}
            <br v-if="curItem.tracking_code" />
            <a
              v-if="curItem.tracking_code"
              href="#"
              @click.prevent="$router.push(`tracking?code=${curItem.tracking_code}&item=${curItem.id}&group=1`)"
            >View tracking code</a>
          </span>
        </span>
      </li>
    </ul>
    <div
      class="sm-mobile-table-item-popup"
      v-if="curItem.popupOpen"
      v-click-outside="hidePopup"
    >
      <ul>
        <li
          v-for="(action, index) in curItem.actions"
          :key="action.name"
          :class="index == 2 ? 'delimiter' : ''"
        >
          <a 
            v-if="!action.processed"
            href="#"
            @click.prevent="$emit('action', {
              action: action.name, 
              id: curItem.id
            })"
          >
            {{action.btn.text}}
          </a>
          <a
              v-else-if="action.result && curItem[action.result.field]"
              :href="curItem[action.result.field]"
              class="result"
              target="_blank"
            >{{action.result.text}}</a>
          <span v-else>{{action.btn.text}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MailParams from '@/settings/mail';
import Hint from '@/components/Hint.vue';
import HintWrap from '@/components/HintWrap';
import vClickOutside from 'v-click-outside';
import ViewPort from '@/mixins/ViewPort';

import Lottie from 'vue-lottie';
import BellAnimationData from '@/assets/json/bell-red.json';

export default {
  name: 'group-mail',
  components: {
    'hint-block': Hint,
    'hint-wrap': HintWrap,
    'lottie': Lottie
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timer: null,
      curItem: {},
      reminderToday: false,
      animationItem: null,
      options: {
        animationData: BellAnimationData,
        autoplay: false,
        loop: false
      },
      allowedBreakpoints: [
        'small',
        'large'
      ],
    };
  },
  created() {
    this.curItem = this.prepareItem(this.item);
    this.reminderToday = this.checkReminder();
  },
  mounted() {
    if (this.reminderToday)
      this.highlightItem();
  },
  mixins: [ViewPort],
  methods: {
    prepareItem(item) {
      return {
        ...item,
        actions: this.prepareActions(),
        popupOpen: false,
        itemOpen: false
      };
    },
    prepareActions() {
      const availableActions = MailParams.available_actions.admin.mail_group;

      return availableActions.map(action => ({
        ...MailParams.group_actions[action],
        showHint: false
      }));
    },
    actionEnter(action) {
      this.timer = setTimeout(() => {
        action.showHint = true;
      }, 500);
    },
    actionLeave(action) {
      action.showHint = false;
      clearTimeout(this.timer);
    },
    showPopup() {
      this.curItem.popupOpen = true;
    },
    hidePopup() {
      this.curItem.popupOpen = false;
    },
    toggleItem() {
      this.curItem.itemOpen = !this.curItem.itemOpen;
    },
    checkReminder() {
      if (
        !this.curItem ||
        !this.curItem.status ||
        !this.curItem.status.includes('REMINDER')
      )
        return false;

      let split = this.curItem.status.split('REMINDER: ');
      let reminderDate = new Date(split[1]);

      if (!reminderDate)
        return false;

      let today = new Date();
      
      return (
        reminderDate.getDate() == today.getDate() &&
        reminderDate.getMonth() == today.getMonth() &&
        reminderDate.getFullYear() == today.getFullYear()
      );
    },
    highlightItem() {
      setTimeout(() => {
        this.$refs.item.classList.add('highlight');
        setTimeout(() => {
          this.$refs.item.classList.remove('highlight');
        }, 300);
      }, 300);
    },
    saveAnimation(item) {
      this.animationItem = item;
    },
    startAnimation() {
      if (this.animationItem) {
        this.animationItem.loop = true;
        this.animationItem.play();
      }
    },
    stopAnimation() {
      if (this.animationItem)
        this.animationItem.loop = false;
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>